/**
 * Shared UI↔wire page-index conversion for the admin paged lists.
 *
 * The dink-api paged endpoints are **0-indexed** (`from = pageIndex * pageSize`),
 * but the admin UI keeps a **1-indexed** page (page 1 is the first page, so
 * "Page X" and next/prev read naturally). These two helpers are the ONE canonical
 * conversion between the two conventions — route every 1-indexed paged list
 * (`listMembers`, `searchContacts`, `listActivityAudit`, `listConfigAudit`)
 * through them so the off-by-one bug (DNKADM-0148: first UI page requested wire
 * `?page=1` and skipped past 0-indexed page 0, surfacing an empty list with a
 * non-zero total) cannot recur.
 *
 * The member ledger (`getMemberLedger`, `audit.ts`) is the one intentional
 * exception: it is 0-indexed in the UI too, so it does NOT use these helpers.
 */

/** UI pages are 1-indexed; the backend is 0-indexed. Convert a 1-indexed UI page to the wire. */
export function toWirePage(uiPage: number): number {
  return Math.max(0, Math.trunc(uiPage) - 1);
}

/** Map a 0-indexed backend page back to the 1-indexed UI page. */
export function toUiPage(wirePage: number): number {
  return Math.max(0, Math.trunc(wirePage)) + 1;
}
